module.exports = __webpack_public_path__ + "img/jonas.5a70d251.jpeg";